import { useEffect, useState } from 'react';
import PacmanLoader from "react-spinners/PacmanLoader";
import "bootstrap/dist/css/bootstrap.min.css";
import { SamplesAcquired } from '@digitalpersona/devices';
import FingerprintReader, { b64UrlTob64 } from '../FingerprintReader'
import MemberController from '../../controllers/MemberController'
import SettingsController from '../../controllers/SettingsController'
import { MemberViewModel } from '../../models/member/MemberViewModel'
import { GetMemberByFingerprintQuery } from '../../models/member/GetMemberByFingerprintQuery/GetMemberByFingerprintQuery';
import moment from 'moment'
import { LoyaltyOptions } from '../../models/loyaltyOptions';
import { SignInToEventCommand } from '../../models/member/SignInToEventCommand/SignInToEventCommand'
import { SignOutOfEventCommand } from '../../models/member/SignOutOfEventCommand/SignOutOfEventCommand'
import CurrentEventViewModel from '../../models/events/currentEventViewModel';

interface IProps {
    currentEvent: CurrentEventViewModel;
    updateAttendeeState: (refresh: boolean) => void;
    setCurrentMember: (member: MemberViewModel | null) => void;
    currentMember: MemberViewModel | null;
}

export default function FindMember(props: IProps) {
    const [loading, setLoading] = useState(false);
    const [acquiring, setAcquiring] = useState<boolean>(false);
    const [dateOfBirth, setDateOfBirth] = useState<string>("");
    const [surname, setSurname] = useState<string>("");
    const [members, setMembers] = useState<MemberViewModel[] | null>()
    const [keyNumber, setKeyNumber] = useState<number>();
    const [useLoyalty, setUseLoyalty] = useState<boolean>(false);
    const [paidMembership, setPaidMembership] = useState(false);
    const [loyaltyOptions, setLoyaltyOptions] = useState<LoyaltyOptions | null>(null);
    const [searchMembersPromise, setSearchMembersPromise] = useState<null | Promise<MemberViewModel[] | null>>(null);
    const fingerprintReader = new FingerprintReader();
    const memberController = new MemberController();
    const settingsController = new SettingsController();
    const date = new Date();
    const hasLoyaltyRequired = (loyalty: number) => {
        if (loyaltyOptions) {
            return loyalty > loyaltyOptions?.LoyaltyRequired;
        }
        return false;
    }

    const setMember = async (member: MemberViewModel) => {
        if (member.Id) {
            var result = await memberController.GetMemberById({ Id: member.Id });
            if (result) {
                setUseLoyalty(hasLoyaltyRequired(result?.Loyalty));
                props.setCurrentMember(result)
            }
        }
    }

    const sampleAcquired = async (sample: SamplesAcquired) => {
        var data = b64UrlTob64(sample.samples[0].Data.toString());
        try {
            var query: GetMemberByFingerprintQuery = {
                Fingerprint: data
            }
            setLoading(true);
            var member = await memberController.GetMemberByFingerprint(query);
            setLoading(false);
            if (member) {
                setMember(member);
            }
            else {
                props.setCurrentMember(null);
            }
        }
        catch (err) {
            console.log(err)
        }
    }
    const beginAcquisition = () => {
        if (!acquiring) {
            fingerprintReader.samplesAcquired = (sample: SamplesAcquired) => { sampleAcquired(sample) };
            fingerprintReader.acquisitionStarted = () => { setAcquiring(true) };
            fingerprintReader.acquisitionStopped = () => { setAcquiring(false) };
            fingerprintReader.startAcquiring();
        }
    }
    beginAcquisition();

    const handleDateChange = async (e: any) => {
        var date = e.target.value;
        setDateOfBirth(date)
        if (date && moment(date, "yyyy-MM-dd").isValid()) {
            var results = await memberController.SearchMembers(date, surname);
            setMembers(results);
        }
    }

    const handleSurnameChange = async (e: any) => {
        var surname = e.target.value;
        setSurname(surname)
        var promise = memberController.SearchMembers(dateOfBirth, surname);
        setSearchMembersPromise(promise);

    }

    useEffect(() => {
        const fetchMembers = async () => {
            if (searchMembersPromise != null) {
                var result = await searchMembersPromise;
                if (searchMembersPromise === searchMembersPromise && result != members) {
                    setMembers(result);
                }
            }
        }
        fetchMembers();
    })

    const getLoyaltyOptions = async () => {
        if (!loyaltyOptions) {
            var options = await settingsController.GetLoyaltyOptions();
            setLoyaltyOptions(options);
        }
    }
    getLoyaltyOptions();

    const signIn = async () => {
        if (props.currentMember && props.currentMember.Id) {
            var model: SignInToEventCommand = {
                MemberId: props.currentMember.Id,
                UseLoyalty: useLoyalty,
                KeyNumber: keyNumber ?? 0,
                PaidMembership: paidMembership
            };
            var result = await memberController.SignIn(model);
            if (result) {
                resetUsers();
            }
        }
    }

    const signOut = async () => {
        if (props.currentMember && props.currentMember.Id) {
            var model: SignOutOfEventCommand = {
                MemberId: props.currentMember.Id,
            };
            var result = await memberController.SignOut(model);
            if (result) {
                resetUsers();
            }
        }
    }

    const membershipDue = (dueDate: Date | undefined) => {
        if (dueDate) {
            if (moment(dueDate) > moment(date)) {
                return false;
            }
            return true;
        }
        return true;
    }

    const resetUsers = () => {
        setKeyNumber(undefined);
        setUseLoyalty(false);
        props.setCurrentMember(null);
        setMembers(null);
        props.updateAttendeeState(true);
    }

    const addNote = async (memberId: string | undefined) => {
        if (memberId && props.currentMember) {
            var note = prompt("Please enter your note")
            if (note) {
                await memberController.AddNoteToMember({ MemberId: memberId, Note: note });
                setMember(props.currentMember)
            }
        }
    }

    const deleteNote = async (noteId: string | undefined) => {
        if (noteId && props.currentMember) {
            var result = confirm("Are you sure you want to delete this note?")
            if (result) {
                await memberController.DeleteNoteFromMember({ NoteId: noteId });
                setMember(props.currentMember);
            }
        }
    }

    return (
        <div className="col-12 mx-auto text-center">
            <h3 className="text-center">Find Member</h3>
            <div>
                {loading && <div className="mb-5"><div className="mx-auto"><PacmanLoader color="#947a27" /></div></div>}
                {!loading && props.currentMember &&
                    <div>
                        <div className={`card text-dark ${props.currentMember.IsBlocked && "bg-danger"} ${!props.currentMember.IsBlocked && "bg-light"} `}>
                            <div className="card-header">
                                <span className={`${props.currentMember.IsBlocked && "text-light"} ${!props.currentMember.IsBlocked && "text-danger"} font-weight-bold`}>
                                    {props.currentMember.IsGuest && <strong><br />GUEST</strong>}
                                    {props.currentMember.IsDeleted && <strong><br />DEACTIVATED</strong>}
                                    {props.currentMember.IsBlocked && <strong><br />BARRED</strong>}
                                    {!props.currentMember.HasFingerprint && <strong><br />FINGERPRINT REQUIRED</strong>}
                                    {membershipDue(props.currentMember.MembershipDue) && <strong><br />MEMBERSHIP DUE</strong>}
                                </span>
                                <br /><a className="btn btn-dark" href={`/editMembership/${props.currentMember.MembershipId}`} >Edit</a>
                            </div>
                            <div className={`card-body ${props.currentMember.IsGuest && "bg-warning"} ${props.currentMember.IsBlocked && "bg-danger"} ${props.currentMember.IsDeleted && "bg-danger"} ${!props.currentMember.HasFingerprint && "bg-success"} ${membershipDue(props.currentMember.MembershipDue) && "bg-primary"}`}>
                                {props.currentMember.Firstname} {props.currentMember.Surname}<br />
                                {moment(props.currentMember.DateOfBirth).format("DD-MM-YYYY")}<br />
                                {props.currentMember.MembershipType}<br />
                                {props.currentMember.IsSwinging && <>Swinging <br /></>}
                                {props.currentMember.IsFetish && <>Fetish <br /></>}
                                Current Loyalty: {props.currentMember.Loyalty} <br />
                                Membership Due Date: {moment(props.currentMember.MembershipDue).format("DD-MM-yyyy")}
                                {props.currentMember.AssociatedMembers && props.currentMember.AssociatedMembers.length > 0 && <hr />}
                                {props.currentMember.AssociatedMembers && props.currentMember.AssociatedMembers.map((member, index) => {
                                    if (member.SignedIn) {
                                        return <p key={index}><span className="text-success">&#10003;</span> {member.Name}</p>;
                                    }
                                    return <p key={index}><span className="text-danger">&#10005;</span> {member.Name}</p>;

                                })}

                            </div>
                            <div className="card-footer">
                                <button type="button" className="btn btn-dark" onClick={() => addNote(props.currentMember?.Id)}>Add Note</button>
                                {props.currentMember.Notes.length > 0 &&
                                    <table className="table">
                                        <tbody>
                                            {props.currentMember.Notes.map((note, index) => {
                                                return <tr key={index.toString()}>
                                                    <td className="col-4">{moment(note.Date).format("ddd DD MMM yyyy")}</td>
                                                    <td style={{ textAlign: "left" }}>{note.Note}</td>
                                                    <td><button className="btn btn-danger" onClick={() => deleteNote(note.Id)}>Delete</button></td>
                                                </tr>
                                            })}
                                        </tbody>
                                    </table>
                                }
                            </div>
                        </div>
                        <br />
                        {!props.currentMember.IsSignedIn ?
                            <div className="row mx-auto">
                                <div className="col-4">
                                    <div className="form-floating mb-3 mx-auto">
                                        <input value={keyNumber} onChange={(e) => setKeyNumber(Number(e.target.value))} type="text" className="form-control" placeholder="Key Number" />
                                        <label htmlFor="floatingInput" className="text-dark">Key Number</label>
                                    </div>
                                </div>
                                <div className="my-auto col-4">
                                    {hasLoyaltyRequired(props.currentMember.Loyalty) &&

                                        <div className="mb-3 form-check" style={{ textAlign: "left" }}>
                                            <input checked={useLoyalty} onChange={(e) => setUseLoyalty(e.target.checked)} type="checkbox" className="form-check-input" />
                                            <label className="form-check-label">Use Loyalty?</label>
                                        </div>
                                    }
                                    {membershipDue(props.currentMember.MembershipDue) &&
                                        <div className="mb-3 form-check" style={{ textAlign: "left" }}>
                                            <input checked={paidMembership} onChange={(e) => setPaidMembership(e.target.checked)} type="checkbox" className="form-check-input" />
                                            <label className="form-check-label">Paid Membership?</label>
                                        </div>
                                    }
                                </div>
                                {!props.currentMember.IsDeleted &&
                                    <div className="my-auto col-4">
                                        <div className="mb-3">
                                            <button className="btn btn-light btn-lg" onClick={signIn}>Sign In</button>
                                        </div>
                                    </div>
                                }
                            </div>
                            :
                            <div className="row mx-auto">
                                <div className="col-4">
                                    <div className="form-floating mb-3 mx-auto">
                                        <input value={props.currentMember.KeyNumber} type="text" className="form-control" placeholder="Key Number" readOnly />
                                        <label htmlFor="floatingInput" className="text-dark">Key Number</label>
                                    </div>
                                </div>
                                <div className="my-auto col-4">
                                </div>
                                <div className="my-auto col-4">
                                    <div className="mb-3">
                                        <button className="btn btn-light btn-lg" onClick={signOut}>Sign Out</button>
                                    </div>
                                </div>
                            </div>}
                    </div>
                }
            </div>
            <br />
            <hr />
            <div className="row">
                <div className="form-floating mb-3 col-6">
                    <input value={dateOfBirth} onChange={handleDateChange} type="date" className="form-control" placeholder="Date of Birth" />
                    <label htmlFor="floatingInput" className="text-dark">Date of Birth</label>
                </div>
                <div className="form-floating mb-3 col-6">
                    <input value={surname} onChange={handleSurnameChange} className="form-control" placeholder="Surname" />
                    <label htmlFor="floatingInput" className="text-dark">Surname</label>
                </div>
            </div>
            {members &&
                <div className="table-wrapper-scroll-y small-scrollbar">
                    <table className="table table-dark">
                        <thead>
                            <tr>
                                <th scope="col">Firstname</th>
                                <th scope="col">Surname</th>
                            </tr>
                        </thead>
                        <tbody>
                            {members.map((member, index) => {
                                return <tr key={index.toString()} onClick={() => { setMember(members[index]) }}>
                                    <td>{member.Firstname}</td>
                                    <td>{member.Surname}</td>
                                </tr>
                            })}
                        </tbody>
                    </table>
                </div>
            }
        </div >
    );
}